export default __webpack_public_path__ + "static/linotte-semibold-cb661f653edf6a0006074b66f3894b75.woff";